import { gql } from '@apollo/client';

export const BaseParticipant = gql`
  fragment BaseParticipant on Participant {
    id
    attendeeId
    firstName
    lastName
    title
    company
    profilePicture
  }
`;

export const BaseRoom = gql`
  ${BaseParticipant}
  fragment BaseRoom on Room {
    id
    participants {
      ...BaseParticipant
    }
    active
    startDate
    seated
  }
`;

export const JOIN_ROOM = gql`
  ${BaseRoom}
  mutation JOIN_ROOM($id: ID!) {
    joinRoom(id: $id) {
      ...BaseRoom
    }
  }
`;

export const JOIN_ROOM_WITH_ERROR = gql`
  ${BaseRoom}
  mutation JOIN_ROOM_WITH_ERROR($id: ID!) {
    joinRoomWithError(id: $id) {
      ... on JoinRoomError {
        errorCode
        isRoomFull
        roomId
      }
      ... on Room {
        ...BaseRoom
      }
    }
  }
`;

export const CREATE_ROOM = gql`
  ${BaseRoom}
  mutation CREATE_ROOM($discussionId: ID!) {
    createRoom(discussionId: $discussionId) {
      ...BaseRoom
    }
  }
`;

export const LEAVE_ROOM = gql`
  ${BaseRoom}
  mutation LEAVE_ROOM($id: ID!) {
    leaveRoom(id: $id) {
      ...BaseRoom
    }
  }
`;

export const JOIN_NEXT_AVAILABLE_ROOM = gql`
  ${BaseRoom}
  mutation JOIN_NEXT_AVAILABLE_ROOM($discussionId: ID!) {
    joinNextAvailableRoom(discussionId: $discussionId) {
      ...BaseRoom
    }
  }
`;

export const VERIFY_TEXT_DISCUSSION_ACCESS = gql`
  mutation VERIFY_TEXT_DISCUSSION_ACCESS($discussionId: ID!) {
    verifyTextDiscussionAccess(discussionId: $discussionId) {
      status
      limit
      remaining
      resetAt
    }
  }
`;

export const VISIT_DISCUSSION = gql`
  mutation VISIT_DISCUSSION($id: ID!) {
    visitDiscussion(id: $id) {
      id
      hasVisited
    }
  }
`;

export const PARTICIPATE_TEXT_DISCUSSION = gql`
  mutation PARTICIPATE_TEXT_DISCUSSION($id: ID!) {
    participateTextDiscussion(id: $id) {
      id
      title
    }
  }
`;
